export const pipelineConstant = {
  // Get default pipeline (single pipeline mode)
  GET_DEFAULT_PIPELINE_R: "GET_DEFAULT_PIPELINE_R",
  GET_DEFAULT_PIPELINE_S: "GET_DEFAULT_PIPELINE_S",
  GET_DEFAULT_PIPELINE_F: "GET_DEFAULT_PIPELINE_F",

  // Update pipeline
  UPDATE_PIPELINE_R: "UPDATE_PIPELINE_R",
  UPDATE_PIPELINE_S: "UPDATE_PIPELINE_S",
  UPDATE_PIPELINE_F: "UPDATE_PIPELINE_F",

  // Delete pipeline
  DELETE_PIPELINE_R: "DELETE_PIPELINE_R",
  DELETE_PIPELINE_S: "DELETE_PIPELINE_S",
  DELETE_PIPELINE_F: "DELETE_PIPELINE_F",

  // Create stage
  CREATE_STAGE_R: "CREATE_STAGE_R",
  CREATE_STAGE_S: "CREATE_STAGE_S",
  CREATE_STAGE_F: "CREATE_STAGE_F",

  UPDATE_STAGE_R: "UPDATE_STAGE_R",
  UPDATE_STAGE_S: "UPDATE_STAGE_S",
  UPDATE_STAGE_F: "UPDATE_STAGE_F",

  DELETE_STAGE_R: "DELETE_STAGE_R",
  DELETE_STAGE_S: "DELETE_STAGE_S",
  DELETE_STAGE_F: "DELETE_STAGE_F",

  // Reorder stages (optimistic update)
  REORDER_STAGES_OPTIMISTIC: "REORDER_STAGES_OPTIMISTIC",

  // Set selected pipeline
  SET_SELECTED_PIPELINE: "SET_SELECTED_PIPELINE",

  // Clear pipeline state
  CLEAR_PIPELINE_STATE: "CLEAR_PIPELINE_STATE",
};
